import React from 'react';
import { Link } from 'react-router-dom';
import SliderMobile from 'components/SliderMobile';
import SliderAdvanced from 'components/SliderAdvanced';
import SliderService from 'components/SliderService';
import ProgramBlock from 'components/ProgramBlock';
import { RootReducersState } from 'redux/reducers';
import * as LinkModel from 'bff/models/link';
import { Recommand, Inscat, RecommandData, Activity } from 'bff/models/info';
import { addFavoriteItem, removeFavoriteItem, unloginAddItem } from 'redux/actions/components/myFavorite.action';
import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import _ from 'lodash';
import { IProps, IState } from './types';
import { CodeId } from 'constants/enums/codeId.enum';
import { InsType } from 'constants/enums/insType.enum';
import MainInsuranceItem from 'components/MainInsuranceItem';
import InsTypeDefines from 'constants/models/insTypeDefines';
import InsTypeDefinesEN from 'constants/models/insTypeDefinesEN';
import commonService from 'utils/commonService';
import { AddFavoriteItem } from 'bff/models/member';
import { RecommandCount, ActivityCount } from 'constants/enums/showCount.enum';
import sweetAlertService from 'utils/sweetAlertService';
import service from 'bff/services/homeService';
// import moment from 'moment';
import moment from 'moment-timezone';
import { SweetAlertIcon } from 'constants/enums/sweetAlertIcon.enum';
import storageService from 'utils/storageService';
import { storageKeys } from 'constants/enums/storageKeys.enum';

class Home extends React.Component<IProps, IState> {
  state: IState = {
    inscats: [],
    recommands: [],
    activities: {
      MORE_ACTIVITY_URL: '',
      ACTIVITY: []
    },
    serviceLinks: [],
    bulletin: {
      BULLETIN: {}
    },
    codeTables: [],
    activeRecommandTypeId: InsType.Travel,
    activeRecommandMoreName: InsTypeDefines[InsType.Travel],
    mainSectionBackground: InsTypeDefinesEN[InsType.Travel]
  }

  componentDidMount = async () => {
    const initSettingRes = await service.fetchInitSetting();
    // console.log(initSettingRes);

    const activeRecommandTypeId = initSettingRes.recommands[0].INS_TYPE_ID;
    const activeRecommandMoreName = InsTypeDefines[activeRecommandTypeId as InsType];

    this.setState({
      inscats: [...initSettingRes.inscats],
      recommands: [...initSettingRes.recommands],
      activities: { ...initSettingRes.activities },
      serviceLinks: [...initSettingRes.serviceLinks],
      bulletin: { ...initSettingRes.bulletin },
      codeTables: [...initSettingRes.codeTables],
      activeRecommandTypeId: activeRecommandTypeId,
      activeRecommandMoreName: activeRecommandMoreName
    });
  }

  componentDidUpdate (preProps: IProps, preState: IState) {
    // 有公告事項，顯示公告
    this.handleShowBulletin(preState);
    // console.log('Home componentDidUpdate');
  }

  handleMainSectionBackground = (theme: string) => {
    if (this.state.mainSectionBackground !== theme) {
      this.setState({ mainSectionBackground: theme });
    }
  };

  handleMainSectionBackgroundVisible = (theme: string) => {
    return this.state.mainSectionBackground === theme ? ' main__background--visible' : '';
  };

  // #region 常見服務區塊 相關方法
  /**
   * @description 建立常見服務區塊元素
   * @param linkChunk 經過 Chunk 的 Service Link 陣列
   */
  handleCreateLinkItem = (linkChunk: LinkModel.Link[][]) => {
    return _.map(linkChunk, (mobileLink: LinkModel.Link[], index: number) => {
      return (
        <SliderService.Item key={index}>
          {
            _.map(mobileLink, (linkVal: LinkModel.Link, index: number) => {
              return (
                <div key={index} className="service__item" onClick={() => commonService.validRedirect(linkVal)}>
                  <span>{linkVal.NAME}</span>
                </div>
              );
            })
          }
        </SliderService.Item>
      );
    });
  }

  // #endregion

  // #region 貼心推薦區塊相關方法

  /**
   * @description 貼心推薦 Tab 切換事件
   * @param typeId 險種代碼
   * @param typeName 險種名稱
   */
  handleRecommandChange = (typeId: string, typeName: string) => {
    if (this.state.activeRecommandTypeId === typeId) return;

    this.setState({
      activeRecommandTypeId: typeId,
      activeRecommandMoreName: InsTypeDefines[typeId as InsType]
    });
  }

  // #endregion

  /**
   * @description 有公告事項，顯示公告
   */
  handleShowBulletin = (preState: any) => {
    /** 判斷公告事項是否更新，顯示公告事項 */
    const showAnnounce = Object.keys(preState.bulletin.BULLETIN).length !== Object.keys(this.state.bulletin.BULLETIN).length &&
      this.state.bulletin && this.state.bulletin.BULLETIN && this.state.bulletin.BULLETIN.END_TIME;

    if (showAnnounce && !storageService.getItem(storageKeys.HomeAnnounceChecked)) {
      commonService.showAnnounceModal(
        this.state.bulletin.BULLETIN.END_TIME || '', this.state.bulletin.BULLETIN.TITLE, this.state.bulletin.BULLETIN.CONTENT
      );
      storageService.setItem(storageKeys.HomeAnnounceChecked, 'checked');
    }
  }

  render () {
    // #region 產生 主視覺各連結卡片

    let mainTitleSection;
    const mainInsuranceItems: JSX.Element[] = [];
    const mainInsuranceBackground: JSX.Element[] = [];
    const mainInsuranceBackgroundMobile: JSX.Element[] = [];
    if (this.state.inscats.length > 0) {
      // 主視覺標題部分
      const mainTitle = commonService.getCodeMsg(this.state.codeTables, CodeId.U002);
      const mainSubTitle = commonService.getCodeMsg(this.state.codeTables, CodeId.U001);
      mainTitleSection = (
        <div className="main__title-section">
          <div className="main__sub-title">
            {mainSubTitle}
          </div>
          <div className="main__title">
            <span>{mainTitle.substring(0, 4)}</span>
            <span className="element__ensure-e-letter">{mainTitle.substring(4, 5)}</span>
            <span>{mainTitle.substring(5)}</span>
          </div>
          <div className="main__desc">{commonService.getCodeMsg(this.state.codeTables, CodeId.U003)}</div>
        </div>
      );
      // 產生主視覺各連結卡片
      _.map(this.state.inscats, (insuranceCategory: Inscat, index: number) => {
        const mainSectionBackground = InsTypeDefinesEN[insuranceCategory.INS_TYPE_ID as InsType];
        // const leftImgUrl = require(`assets/images/${insuranceCategory.IMAGE_LEFT_PC}`);
        // const rightImgUrl = require(`assets/images/${insuranceCategory.IMAGE_RIGHT_PC}`);
        // const mobileImgUrl = require(`assets/images/${insuranceCategory.IMAGE_LEFT_MOBILE}`);
        const leftImgUrl = commonService.convertImageUrl(insuranceCategory.IMAGE_LEFT_PC);
        const rightImgUrl = commonService.convertImageUrl(insuranceCategory.IMAGE_RIGHT_PC);
        const mobileImgUrl = commonService.convertImageUrl(insuranceCategory.IMAGE_LEFT_MOBILE);

        // 主視覺背景圖片
        mainInsuranceBackground.push(
          <div key={index} className={'main__background' + this.handleMainSectionBackgroundVisible(mainSectionBackground)} style={{ backgroundImage: `url(${leftImgUrl}), url(${rightImgUrl})` }} />
        );

        // 主視覺背景圖片-Mobile
        mainInsuranceBackgroundMobile.push(
          <div key={index} className={'main__background main__background--mobile ' + this.handleMainSectionBackgroundVisible(mainSectionBackground)} style={{ backgroundImage: `url(${mobileImgUrl})` }} />
        );

        mainInsuranceItems.push(
          <MainInsuranceItem key={insuranceCategory.SN} {...insuranceCategory} handleMouseOver={() => this.handleMainSectionBackground(mainSectionBackground)} />
        );
      });
    };

    // #endregion

    // #region 產生貼心推薦區域

    let recommandTabs = null;
    let recommandAreaTitle = null;
    let recommandBlocks = null;
    let recommandBlocksMobile = null;
    let recommandLink = null;
    if (this.state.recommands.length > 0) {
      // 產生貼心推薦選單 Tab
      recommandTabs = _.map(this.state.recommands, (recommandData: RecommandData, index: number) => {
        const className = recommandData.INS_TYPE_ID === this.state.activeRecommandTypeId
          ? 'recommend__tab recommend__tab--active'
          : 'recommend__tab';
        return (
          <div
            key={index}
            className={className}
            onClick={() => this.handleRecommandChange(recommandData.INS_TYPE_ID, recommandData.INS_TYPE_NAME)}
          >
            <span>{recommandData.INS_TYPE_NAME}</span>
          </div>
        );
      });

      // 產生貼心推薦區域 Title
      const codeMsg = commonService.getCodeMsg(this.state.codeTables, CodeId.U004);
      recommandAreaTitle = (
        <p>
          {codeMsg.substring(0, 13)} <br />
          {codeMsg.substring(13)}
        </p>
      );

      const recommandData = _.find(this.state.recommands, (recommands: RecommandData) => {
        return recommands.INS_TYPE_ID === this.state.activeRecommandTypeId;
      });

      // 產生貼心推薦卡片區塊
      if (recommandData) {
        // PC 區塊
        recommandBlocks = (
          <>
            {_.map(recommandData.RECOMMAND, (recommand: Recommand, index: number) => {
              if (moment() > moment(recommand.END_DATE)) return;
              if (index >= RecommandCount.Home) return;
              // 新增我的收藏用 Model
              const addFavoriteItem: AddFavoriteItem = commonService.getAddFavoriteItem(recommand.INS_TYPE_ID, recommand.PROD_ID, recommand.PLAN_ID);
              // 移除用的 SN 或 planId
              const removeId = commonService.getFavoriteItemSN(this.props.myFavoriteList, recommand.INS_TYPE_ID, recommand.PROD_ID, recommand.PLAN_ID);
              return (
                <div className="recommend__program-item" key={index}>
                  <ProgramBlock
                    key={index}
                    active={commonService.matchFavorite(this.props.myFavoriteList, recommandData.INS_TYPE_ID, recommand.PROD_ID, recommand.PLAN_ID)}
                    insTypeId={recommand.INS_TYPE_ID}
                    content={recommand}
                    onAddItem={() => this.props.onAddFavoriteItem(addFavoriteItem)}
                    onRemoveItem={() => this.props.onRemoveFavoriteItem(removeId)}
                    unloginAddItem={() => this.props.unloginAddItem(recommandData.INS_TYPE_ID, recommand.PROD_ID, recommand.PLAN_ID)}
                  />
                </div>
              );
            })}
          </>
        );
        // Mobile 區塊
        recommandBlocksMobile = (
          <SliderMobile
            name="recommend-programs-mobile-slider"
            config={{ slidesPerView: 1 }}
          >
            {_.map(recommandData.RECOMMAND, (recommand: Recommand, index: number) => {
              if (moment() > moment(recommand.END_DATE)) return;
              if (index >= RecommandCount.Home) return;
              // 新增我的收藏用 Model
              const addFavoriteItem: AddFavoriteItem = commonService.getAddFavoriteItem(recommand.INS_TYPE_ID, recommand.PROD_ID, recommand.PLAN_ID);
              // 移除用的 SN 或 planId
              const removeId = commonService.getFavoriteItemSN(this.props.myFavoriteList, recommand.INS_TYPE_ID, recommand.PROD_ID, recommand.PLAN_ID);
              return (
                <SliderMobile.Item key={index}>
                  <ProgramBlock
                    key={index}
                    active={commonService.matchFavorite(this.props.myFavoriteList, recommandData.INS_TYPE_ID, recommand.PROD_ID, recommand.PLAN_ID)}
                    insTypeId={recommand.INS_TYPE_ID}
                    content={recommand}
                    onAddItem={() => this.props.onAddFavoriteItem(addFavoriteItem)}
                    onRemoveItem={() => this.props.onRemoveFavoriteItem(removeId)}
                    unloginAddItem={() => this.props.unloginAddItem(recommandData.INS_TYPE_ID, recommand.PROD_ID, recommand.PLAN_ID)}
                  />
                </SliderMobile.Item>
              );
            })}
          </SliderMobile>
        );

        // 產生試算其他方案連結
        if (recommandData.INS_TRIAL_URL.indexOf('/insure-process') !== -1) {
          recommandLink = (
            <Link
              to={() => {
                commonService.setActiveProdId(recommandData.INS_TYPE_ID, '');
                return { pathname: recommandData.INS_TRIAL_URL, state: { insTypeId: recommandData.INS_TYPE_ID } };
              }}
            >
              試算{this.state.activeRecommandMoreName}其他方案
            </Link>
          );
        } else {
          recommandLink = (
            <a
              href={recommandData.INS_TRIAL_URL}
              target="_blank"
              rel="noopener noreferrer"
            >
              試算{this.state.activeRecommandMoreName}其他方案
            </a>
          );
        }
      }
    }

    // #endregion

    // #region 產生熱門活動區塊資料

    let sliderAdvanced = null;
    if (this.state.activities.ACTIVITY.length > 0) {
      let imgCount = 0;
      const sliderAdvancedItems = _.map(this.state.activities.ACTIVITY, (activity: Activity, index: number) => {
        if (moment() > moment(activity.END_DATE)) return;
        imgCount += 1;
        if (imgCount > ActivityCount.Home) return;
        try {
          return (
            <SliderAdvanced.Item title={activity.TITLE} desc={activity.BRIEF} key={index} activityUrl={activity.ACTIVITY_URL}>
              <span>
                <img src={activity.IMAGE_NAME_PC} alt={activity.TITLE} className="activity__slider-image-pc" />
                <img src={activity.IMAGE_NAME_MOBILE} alt={activity.TITLE} className="activity__slider-image-mobile" />
              </span>
            </SliderAdvanced.Item>
          );
        } catch (ex) {
          sweetAlertService.modal({
            icon: SweetAlertIcon.Info,
            title: '無法取得熱門活動圖片'
          });
          return null;
        }
      });

      sliderAdvanced = (
        <SliderAdvanced
          name="activity__slider"
          moreBlockText={commonService.getCodeMsg(this.state.codeTables, CodeId.U017)}
          moreBlockLink={this.state.activities.MORE_ACTIVITY_URL}
        >
          {sliderAdvancedItems}
        </SliderAdvanced>
      );
    }

    // #endregion

    // #region 取得常用服務連結區塊資料

    let sliderPer = null;
    let sliderPerMobile = null;
    if (this.state.serviceLinks.length > 0) {
      const linkChunk = _.chunk([...this.state.serviceLinks], 1);
      sliderPer = (
        <SliderService name="service__slider">
          {this.handleCreateLinkItem(linkChunk)}
        </SliderService>
      );

      const mobileLinkChunk = _.chunk([...this.state.serviceLinks], 3);

      sliderPerMobile = (
        <SliderService name="service-mobile__slider">
          {this.handleCreateLinkItem(mobileLinkChunk)}
        </SliderService>
      );
    }

    // #endregion

    return (
      <div className="home">
        {/* 首頁主視覺 */}
        <div className="main">
          <div className="main__content">
            {mainTitleSection}
            <div className="main__insurance-list">
              {mainInsuranceItems}
            </div>
          </div>
          {mainInsuranceBackground}
          {mainInsuranceBackgroundMobile}
        </div>
        {/* 貼心推薦 */}
        <div className="recommend">
          <div className="template-container">
            <div className="template-content">
              <div className="recommend__title-section">
                {/*
                <div className="recommend__sub-title">
                  <span className="element__ensure-e-letter">e</span>
                  <span>NSURE</span>
                </div>
                */}
                <div className="recommend__title">貼心推薦</div>
                <div className="recommend__desc">
                  {recommandAreaTitle}
                </div>
                <div className="recommend__tabs">
                  <div className="recommend__tabs-wrap">
                    {recommandTabs}
                  </div>
                </div>
              </div>
              <div className="recommend__programs">
                {recommandBlocks}
              </div>
              <div className="recommend__programs-mobile">
                {recommandBlocksMobile}
              </div>
            </div>
            <div className="recommend__more">
              {recommandLink}
            </div>
          </div>
        </div>
        {/* 熱門活動 */}
        <div className="activity">
          <div className="template-container">
            <div className="template-content">
              <div className="activity__title-section">
                {/*
                <div className="activity__sub-title">
                  <span className="element__ensure-e-letter">e</span>
                  <span>NSURE</span>
                </div>
                */}
                <div className="activity__title">熱門活動</div>
              </div>
            </div>
            <div className="activity__slider-section">
              <div className="activity__slider-container">
                {sliderAdvanced}
              </div>
            </div>
          </div>
        </div>
        {/* 常用服務 */}
        <div className="service">
          <div className="template-section">
            <div className="template-container">
              <div className="template-content">
                <div className="service__title-section">
                  {/*
                  <div className="service__sub-title">
                    <span className="element__ensure-e-letter">e</span>
                    <span>NSURE</span>
                  </div>
                  */}
                  <div className="service__title">常用服務</div>
                </div>
                <div className="service__slider-section">
                  <div className="service__slider-container">
                    {sliderPer}
                  </div>
                </div>
                <div className="service-mobile__slider-section">
                  <div className="service-mobile__slider-container">
                    {sliderPerMobile}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
};

const mapStateToProps = (state: RootReducersState) => {
  return {
    myFavoriteList: state.myFavorite.myFavoriteList
  };
};

const mapDisatchToProps = (dispatch: Dispatch) => {
  return {
    onAddFavoriteItem: (item: AddFavoriteItem) => dispatch(addFavoriteItem(item)),
    onRemoveFavoriteItem: (sn: any) => dispatch(removeFavoriteItem(sn)),
    unloginAddItem: (insTypeId: string, prodId: string, planId: string) => dispatch(unloginAddItem(insTypeId, prodId, planId))
  };
};

export default connect(mapStateToProps, mapDisatchToProps)(Home);
